/**
 * Modelo de formatação do model-map.
 * @category ModelMaps
 * @interface ModelMapFormat
 * @hideconstructor
 */

export class ModelMapFormat {
  index: number;
  parentIndex: number;
  childIndex: number;
  description: string;
  quantity: string;
  unit: string;

  constructor(
    index: number,
    parentIndex: number,
    childIndex: number,
    description: string,
    quantity: string,
    unit: string
  ) {
    /** Índice da linha da formatação.
     * @type {number}
     */
    this.index = index;
    /** Índice da etapa da linha da formatação.
     * @type {number}
     */
    this.parentIndex = parentIndex;
    /** Índice da linha como filho da etapa.
     * @type {number}
     */
    this.childIndex = childIndex;
    /** Descrição da formatação.
     * @type {string}
     */
    this.description = description;
    /** Fórmula do quantitativo da formatação.
     * @type {string}
     */
    this.quantity = quantity;
    /** Unidade do quantitativo da formatação.
     * @type {string}
     */
    this.unit = unit ? unit : "";
  }
}



// WEBPACK FOOTER //
// ./src/modules/modelMap/models/ModelMapFormat.ts